import { normalize, schema } from 'normalizr'
import { createSelector } from 'reselect'
import { IOrganizationPromotionsState, IPromotion } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import * as constants from '../../constants/'
import { IOrganizationActions } from '../../actions/organizations'

const initOrganizationsState: IOrganizationPromotionsState = {
  items: {},
  metadata: {
    fetchingList: false,
    listFetchError: '',
    processingCreation: false,
    creationError: '',
    processingDeletion: false,
    deletionError: ''
  },
  filters: {},
  promotionCount: 0,
  riders: [],
  riderCount: 0
}

export function organizationPromotions(
  state: IOrganizationPromotionsState = initOrganizationsState,
  action: IOrganizationActions
): IOrganizationPromotionsState {
  switch (action.type) {
    case constants.GET_RIDERS_PER_PROMOTION_REQUEST:
    case constants.FETCH_ORGANIZATION_PROMOTIONS: {
      return Object.assign({}, state, {
        ...state.metadata,
        fetchingList: true
      })
    }
    case constants.FETCH_ORGANIZATION_PROMOTIONS_FAIL: {
      return Object.assign({}, state, {
        ...state.metadata,
        fetchingList: false,
        listFetchError: action.payload
      })
    }
    case constants.FETCH_ORGANIZATION_PROMOTIONS_SUCCESS: {
      const promotionsSchema = [new schema.Entity('promotion')]
      const { entities } = normalize(action.payload.promotions, promotionsSchema)
      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          fetchingList: false
        },
        items: {
          ...entities.promotion
        }
      })
    }
    case constants.FETCH_ORGANIZATION_PROMOTIONS_COUNT_SUCCESS: {
      return Object.assign({}, state, {
        ...state.metadata,
        fetchingList: false,
        promotionCount: action.payload
      })
    }
    case constants.UPDATE_PROMOTIONS_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.CREATE_PROMOTION: {
      return Object.assign({}, state, {
        ...state.metadata,
        processingCreation: true
      })
    }
    case constants.CREATE_PROMOTION_FAIL: {
      return Object.assign({}, state, {
        ...state.metadata,
        processingCreation: false,
        creationError: action.payload
      })
    }
    case constants.CREATE_PROMOTION_SUCCESS: {
      const promotionsSchema = [new schema.Entity('promotion')]
      const { entities } = normalize([action.payload], promotionsSchema)

      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          processingCreation: false
        },
        items: {
          ...state.items,
          ...entities.promotion
        }
      })
    }
    case constants.DELETE_PROMOTION: {
      return Object.assign({}, state, {
        ...state.metadata,
        processingDeletion: true
      })
    }
    case constants.DELETE_PROMOTION_FAIL: {
      return Object.assign({}, state, {
        ...state.metadata,
        processingDeletion: false,
        deletionError: action.payload
      })
    }
    case constants.DELETE_PROMOTION_SUCCESS: {
      const promotionsSchema = [new schema.Entity('promotion')]
      const { entities } = normalize([action.payload], promotionsSchema)

      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          processingDeletion: false
        },
        items: {
          ...state.items,
          ...entities.promotion
        }
      })
    }
    case constants.GET_RIDERS_PER_PROMOTION_SUCCESS: {
      return Object.assign({}, state, {
        riders: action.payload
      })
    }
    case constants.GET_RIDERS_PER_PROMOTION_COUNT: {
      return Object.assign({}, state, {
        riderCount: action.payload
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/organizations/promotions.ts